import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { firstValueFrom } from 'rxjs';
import { MaterialModule } from 'src/app/material.module';
import { authService } from 'src/app/services/auth.service';
import { DisplayFileComponent } from 'src/app/shared/display-file/display-file.component';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-info-modal',
  standalone: true,
  imports: [CommonModule, MaterialModule,DisplayFileComponent],
  templateUrl: './info-modal.component.html',
  styleUrls: ['./info-modal.component.scss']
})
export class InfoModalComponent implements OnInit {
  safeContent: SafeHtml;
  backendUrl = environment.apiUrl;

  constructor(
    public dialogRef: MatDialogRef<InfoModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private sanitizer: DomSanitizer,
    private authService:authService
  ) {}

  async ngOnInit() {
     if (this.data?.chat?.attachments?.length>0) {
            const attachmentsToSign = this.data?.chat?.attachments.filter(
              (attachment) => ['image', 'video', 'audio'].includes(attachment.type) && !attachment.signUrl
            );
            
            if (attachmentsToSign.length > 0) {
              const obj = {
                keys: attachmentsToSign,
                expSeconds: 3600,
                type: 'messages'
              };
              
              const response: any = await firstValueFrom(this.authService.getSignUrls(obj));
              
              this.data.chat.attachments = this.data.chat.attachments.map((attachment) => {
                const signedUrlObj = response.signedUrls.find(
                  (signed) => signed.cloud_key === attachment.cloud_key
                );
                return signedUrlObj ? { ...attachment, signUrl: signedUrlObj.signUrl } : attachment;
              });
            }
          }
    

    this.safeContent = this.sanitizer.bypassSecurityTrustHtml(this.data.chat.content);
  }

}
